import React, { FC } from 'react';
import Button, { ButtonProps } from './Button';
import useTranslation from 'hooks/useTranslation';

export interface CancelButtonProps extends ButtonProps {
  label?: string;
}

const CancelButton: FC<CancelButtonProps> = ({
  label,
  variant = 'text',
  color = 'secondary',
  ...rest
}) => {
  const { t } = useTranslation();
  return (
    <Button variant={variant} color={color} {...rest}>
      {label || t('cancel')}
    </Button>
  );
};

export default CancelButton;
